/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrIconModule } from "../../icon/icon.module";
import { ClrFormsModule } from "../../forms/forms.module";
import { FormsModule } from "@angular/forms";
import { ClrCommonPopoverModule } from "../../popover/common/popover.module";
import { ClrLoadingModule } from "../../utils/loading/loading.module";
import { DATAGRID_DIRECTIVES } from "./index";
import { ClrOutsideClickModule } from "../../utils/outside-click/outside-click.module";
var ClrDatagridModule = (function () {
    function ClrDatagridModule() {
    }
    return ClrDatagridModule;
}());
export { ClrDatagridModule };
ClrDatagridModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrIconModule,
                    ClrFormsModule,
                    FormsModule,
                    ClrCommonPopoverModule,
                    ClrLoadingModule,
                    ClrOutsideClickModule
                ],
                declarations: [
                    DATAGRID_DIRECTIVES,
                ],
                exports: [
                    DATAGRID_DIRECTIVES
                ]
            },] },
];
/** @nocollapse */
ClrDatagridModule.ctorParameters = function () { return []; };
//# sourceMappingURL=datagrid.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/datagrid.module.js
// module id = 162
// module chunks = 4